export const mapDeliveryStatusToJobStatus = (deliveryStatus) => {
  const statusMap = {
    delivered: "PROCESS_COMPLETED",
    failed: "EMAIL_FAILED",
    processing: "UPLOADED",
  };
  return statusMap[deliveryStatus?.toLowerCase()] || "UPLOADED";
};

export const extractJobStatuses = (logs) => {
  const jobStatuses = [...new Set(logs.map((item) => item.job_status))];
  return jobStatuses.map((status) => ({
    name: status,
    value: status,
  }));
};

export const dedupeLogs = (logs) => {
  const seenIds = new Set();
  return logs.filter((log) => {
    const key = String(log?.id || `${log?.job_name || ""}-${log?.created_at || ""}`);
    if (seenIds.has(key)) {
      return false;
    }
    seenIds.add(key);
    return true;
  });
};

export const mapApiLog = (log) => ({
  id: log.id,
  client_id: Number(log.client_id || 0),
  job_name: log.job_name || log.id?.toString() || "",
  email_from_name: log.email_from_name || log.username || "",
  email_from_address: log.email_from_address || log.caller_id || "",
  to_email_addresses: log.to_email_addresses || log.deliver_to || "",
  email_subject:
    log.email_subject || `Voicemail from ${log.caller_id || "Unknown"}`,
  // Prefer backend lifecycle status; fallback to delivery-status mapping for legacy payloads.
  job_status:
    log.job_status || mapDeliveryStatusToJobStatus(log.delivery_status),
  delivery_status: String(log.delivery_status || "").toLowerCase(),
  email_status: log.email_status || "",
  created_time:
    log.created_at || log.delivery_timestamp || new Date().toISOString(),
  delivery_timestamp: log.delivery_timestamp || "",
  sms_delivery_status: String(log.sms_delivery_status || ""),
  sms_delivery_timestamp: log.sms_delivery_timestamp || "",
  duration_ms:
    log.duration_ms === null || log.duration_ms === undefined
      ? null
      : Number(log.duration_ms),
  updated_at: log.updated_at || "",
  _original: log,
});

export const sortLogsByCreatedTimeDesc = (logs) =>
  [...logs].sort((a, b) => {
    const dateA = new Date(a.created_time);
    const dateB = new Date(b.created_time);
    return dateB - dateA;
  });
